
<div>
    <f-read-only-field
        v-if   = "readonly"
        class  = "w-100"
        :dense = "true"
        :label = "label"
        :value = "number"
        color  = "pt-0-5 pl-1 ro-background"
    />

    <v-text-field
        v-if           = "!readonly"
        type           = "number"
        :label         = "label"
        v-model        = "number"
        :readonly      = "readonly"
        autocomplete   = "off"
        autocorrect    = "off"
        autocapitalize = "off"
        spellcheck     = "false"
        :hide-details  = "hideDetails"
        :dense = "dense"
        :outlined = "outlined"
        @input         = "onInput"
    />
</div>
